export const RESPONSE_STATUS = 'RESPONSE_STATUS'
export const CLEAR_RESPONSE = 'CLEAR_RESPONSE'
export const GET_SCHEDULE_DATA = 'GET_SCHEDULE_DATA'
